import React from "react";
import { Card, CardContent, Typography, Box, Button } from "@mui/material";
import { ArrowUpward, ArrowDownward } from "@mui/icons-material";

const StatCard = ({ title, contents, percentage, icon: Icon, color }) => {
  return (
    <Card sx={{ display: "flex", alignItems: "center", p: 0.5, borderRadius: 1, boxShadow: 1 }}>
      <Box
        sx={{
          width: 130,
          height: 40,
          borderRadius: "80%",
          backgroundColor: color,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          mr: 1,
        }}
      >
        <Icon sx={{ color: "white", fontSize: 16 }} />
      </Box>
      <CardContent sx={{ flexGrow: 1, p: 0 }}>
        <Typography variant="caption" color="text.primary" fontWeight="bold" sx={{ mb: 0.5 }}>
          {title.toUpperCase()}
        </Typography>
        <Typography variant="body2" fontWeight="light"  sx={{ color: 'text.secondary' }}>
          {contents}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default StatCard;
